import { DECEASED_TAG_ID, sortPatientTags } from 'mobx/stores/ConstantsStore';

import PatientTag from 'models/PatientTag';

/**
 * Processes patient tags by adding a deceased tag if the patient is deceased,
 * removing any existing deceased tags to avoid duplicates, and sorting the tags.
 *
 * @param patientTags - Array of patient tags
 * @param isDeceased - Whether the patient is deceased
 * @returns Sorted array of patient tags with deceased tag if applicable
 */
export const processPatientTags = (
  patientTags: PatientTag[],
  isDeceased: boolean
): PatientTag[] => {
  let processedTags = [...patientTags];

  if (isDeceased) {
    // Remove any existing "Deceased" tags to avoid duplicates
    processedTags = processedTags.filter((tag) => tag.name !== 'Deceased');
    // Add pseudo deceased tag with the highest priority
    processedTags.push(
      new PatientTag({ name: 'Deceased', id: DECEASED_TAG_ID, priority: Infinity })
    );
  }

  return sortPatientTags(processedTags);
};
